import React from 'react';
import {
  Box,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TableFooter,
  TablePagination,
} from '@material-ui/core';
import { map } from 'lodash';
import TablePaginationActions from '../TablePaginationActions';
import { LIST_PAGE_COUNT } from '../../data/common';
import UserPayingMemberTableRow from './UserPayingMemberTableRow';

const UserPayingMemberTable = (props) => {
  const {
    userPayingMembers,
    total,
    pageNum,
    setPageNum,
    onCancelPayingMember,
    onOpenCouponModal,
    onOpenTransferModal,
  } = props;

  return (
    <TableContainer component={Box}>
      <Table aria-label="customized table">
        <TableHead>
          <TableRow>
            <TableCell>ID</TableCell>
            <TableCell>會員</TableCell>
            <TableCell>方案</TableCell>
            <TableCell>分店</TableCell>
            <TableCell>升級時間</TableCell>
            <TableCell>開始日期</TableCell>
            <TableCell>結束日期</TableCell>
            <TableCell>付款方式</TableCell>
            <TableCell>訂單</TableCell>
            <TableCell>結帳人員</TableCell>
            <TableCell>推薦人員</TableCell>
            <TableCell>轉讓人</TableCell>
            <TableCell>取消狀態</TableCell>
            <TableCell>領券</TableCell>
            <TableCell>操作</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {map(userPayingMembers, (userPayingMember) => (
            <UserPayingMemberTableRow
              key={userPayingMember.id}
              userPayingMember={userPayingMember}
              onCancelPayingMember={onCancelPayingMember}
              onOpenCouponModal={onOpenCouponModal}
              onOpenTransferModal={onOpenTransferModal}
            />
          ))}
        </TableBody>
        <TableFooter>
          <TableRow>
            <TablePagination
              rowsPerPageOptions={[LIST_PAGE_COUNT]}
              colSpan={15}
              count={total}
              rowsPerPage={LIST_PAGE_COUNT}
              page={pageNum - 1}
              SelectProps={{
                inputProps: { 'aria-label': 'rows per page' },
                native: true,
              }}
              onChangePage={(event, currentPage) => {
                setPageNum(currentPage + 1);
              }}
              ActionsComponent={TablePaginationActions}
            />
          </TableRow>
        </TableFooter>
      </Table>
    </TableContainer>
  );
};

export default UserPayingMemberTable;
